import { useContext, useEffect, useState } from "react";
import ContextFlujos from "../Context/ContextFlujos";
import QuejasSugerencias from "../Ayuda/QuejasSugerencias";
import { Col, Container, Row } from "react-bootstrap";
import styles from '../Control/ControlComponente.module.css';
import ControlComponente from "../Control/ControlComponente";

const Control = () => {
  const { setSkyPlus, setSkyCelular, pais, setPais, setDTHSkyPlus } = useContext(ContextFlujos) as any;

  useEffect(() => {
    if (sessionStorage.getItem("flujos") === "Sky+") {
        setSkyPlus({estado:false});
        setDTHSkyPlus({ estado: false });

      }

      if (sessionStorage.getItem("flujos") ===  "DTH/SkyCelular" || sessionStorage.getItem("flujos") ===  "DTH/DTH/SkyCelular/Sky+") {
        setSkyCelular({estado:true});
      }

      if (sessionStorage.getItem("flujos") ===  "DTH/Sky+" || sessionStorage.getItem("flujos") ===  "DTH/SkyCelular/Sky+") {
        setDTHSkyPlus({estado:false});
      }
  
      if (sessionStorage.getItem("flujos") ===  "DTH" || sessionStorage.getItem("flujos") ===  "DTH/SkyCelular") {
        setDTHSkyPlus({estado:true});
      }
    
      setPais(sessionStorage.getItem("pais"));
  }, []);

  return (
    <>
        <Container className={styles.containerPagina}>
            <Row>
                <Col>
                    <h2  className={styles.tituloPagina}><span className="textoSpectrum">Control Remoto</span></h2>                
                </Col>
            </Row>
            <Row >
                <Col>
                    <p className={styles.textoPagina}>¿Necesitas un control remoto nuevo? consíguelo aquí.</p>                
                </Col>
            </Row>
         
            <ControlComponente/>
        </Container>

        
    </>
  );
};

export default Control;
